export default "__VITE_ASSET__BrMhekPc__"